export type TimeWindow = "full" | 15 | 30 | 60;

export const INITIAL_TIME_WINDOW: TimeWindow = 30;
const WINDOW_ORDER: readonly TimeWindow[] = ["full", 60, 30, 15];

export type ViewerNavigationState = {
  selectedSeconds: number;
  timeWindow: TimeWindow;
};

export function clampSelectedTime(seconds: number, recordingDuration: number): number {
  return Math.max(0, Math.min(Math.max(0, recordingDuration), seconds));
}

export function detailWindowStart(
  selectedSeconds: number,
  duration: 15 | 30 | 60,
  recordingDuration: number,
): number {
  return Math.max(
    0,
    Math.min(Math.max(0, recordingDuration - duration), selectedSeconds - duration / 2),
  );
}

export function timelineSecondsAtClientX(
  clientX: number,
  left: number,
  width: number,
  recordingDuration: number,
): number {
  if (width <= 0) return 0;
  const ratio = Math.max(0, Math.min(1, (clientX - left) / width));
  return ratio * Math.max(0, recordingDuration);
}

export function isActiveTimelineDrag(activePointer: number | null, pointerId: number, hasCapture: boolean): boolean {
  return activePointer === pointerId && hasCapture;
}

export function stepTimeWindow(timeWindow: TimeWindow, direction: "in" | "out"): TimeWindow {
  const current = WINDOW_ORDER.indexOf(timeWindow);
  const offset = direction === "in" ? 1 : -1;
  return WINDOW_ORDER[Math.max(0, Math.min(WINDOW_ORDER.length - 1, current + offset))];
}

export function applyViewerArrowKey(
  state: ViewerNavigationState,
  key: "ArrowLeft" | "ArrowRight" | "ArrowUp" | "ArrowDown",
  recordingDuration: number,
): ViewerNavigationState {
  if (key === "ArrowUp" || key === "ArrowDown") {
    return {
      ...state,
      timeWindow: stepTimeWindow(state.timeWindow, key === "ArrowUp" ? "in" : "out"),
    };
  }
  const increment = state.timeWindow === "full" ? 30 : state.timeWindow;
  return {
    ...state,
    selectedSeconds: clampSelectedTime(
      state.selectedSeconds + (key === "ArrowLeft" ? -increment : increment),
      recordingDuration,
    ),
  };
}

export function hasNativeArrowKeyBehavior(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  if (target.closest("input, select, textarea, button, [contenteditable]:not([contenteditable='false'])")) return true;
  return Boolean(target.closest("[role='combobox'], [role='listbox'], [role='menu'], [role='radio'], [role='spinbutton']"));
}
